import webui, { BaseComponent } from "@tinqin/tinqin-web-ui";
import EntityBuilder from "@tinqin/tinqin-web-ui/src/utils/EntityBuilder";

//Manages logic for show hide tabs or contact form or nothing
class ArticleOfferContactTabs extends BaseComponent {
    render() {
        if (!this.props.data) {
            return "";
        }
        const data = this.props.data || {};
        const siren = EntityBuilder.of(data);
        const checkContactForm = siren.hasChild("contactFormSection");
        const checkPDF = siren.hasChild("openPDF");
        const checkCalculation = siren.hasChild("calculation");
        const regions = this.resolveRegions();
        if (checkPDF || checkCalculation) {
            return regions["tabs"] || "";
        } else if (checkContactForm) {
            return regions["contactForm"] || "";
        }
        return "";
    }
}

export default webui.connectComponent()(ArticleOfferContactTabs);
